import React from 'react';
import styles from './PlanSelection.less';
import { TrialLength } from './types';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { MiniPlanOverviewSection } from './MiniPlanOverviewSection';

interface PlanSelectionProps {
  trialLength?: TrialLength;
}

export const PlanSelection: React.FC<PlanSelectionProps> = ({
  trialLength,
}) => {
  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-mocha',
        feature: !trialLength
          ? 'Expired Free Trial Existing Team'
          : 'Free Trial Existing Team',
      }}
    >
      <div className={styles.bodyWrapper}>
        <MiniPlanOverviewSection plan="free" />
        <MiniPlanOverviewSection plan="standard" />
        <MiniPlanOverviewSection plan="premium" />
      </div>
    </ErrorBoundary>
  );
};
